// One marker covers one page, so a repeated marker means several claims on
// that page. The synthesis protocol puts each claim's verbatim quote right
// before its marker, so the nearest preceding quote says which target this
// occurrence is about — the same key the server splits pages on. No match (a
// reworded claim, a quote left in a sibling markdown node) means no focused
// target, and the whole page's boxes stay highlighted as before.
const QUOTE_RE = /"([^"]{2,240})"|“([^”]{2,240})”|‘([^’]{2,240})’/g

const fold = (value) =>
  String(value ?? '')
    .normalize('NFKC')
    .replace(/[“”]/g, '"')
    .replace(/[‘’]/g, "'")
    .replace(/[–—]/g, '-')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase()

export function lastQuoteIn(text) {
  QUOTE_RE.lastIndex = 0
  let quote = ''
  let match
  while ((match = QUOTE_RE.exec(text ?? '')) !== null) {
    quote = match[1] ?? match[2] ?? match[3] ?? ''
  }
  return quote.trim()
}

export function targetIndexForQuote(citation, quote) {
  const targets = citation?.targets
  if (!Array.isArray(targets) || targets.length === 0) return -1
  const key = fold(quote)
  if (!key) return -1
  const folded = targets.map((target) => fold(target?.quote))
  const exact = folded.indexOf(key)
  if (exact !== -1) return exact
  return folded.findIndex((other) => other && (other.includes(key) || key.includes(other)))
}
